import React, { useContext } from 'react'
import { FormLayoutRow } from '@pushly/aqe/lib/components'
import { Form, Input, Space } from 'antd'
import { PromptVisitorConditions } from '@pushly/models/lib/structs/prompts/prompt-visitor-conditions'
import { DEFAULT_SESSION_TIME_ON_SITE_SECONDS } from '../../constants'
import { PromptEditorContext } from '../../context'

type Props = {
    value: PromptVisitorConditions | undefined
    onChange: (update: PromptVisitorConditions) => void
}

export const SessionTimeOnSiteCondition: React.FC<Props> = ({ value, onChange }) => {
    const { loading, selectedPromptIdx } = useContext(PromptEditorContext)

    return !loading ? (
        <Space.Compact size="medium">
            <Input
                key={selectedPromptIdx}
                placeholder="0"
                className="vc-time-on-site"
                type="number"
                min={0}
                defaultValue={value?.sessionTimeOnSiteSeconds ?? DEFAULT_SESSION_TIME_ON_SITE_SECONDS}
                onChange={(ev) => {
                    onChange(
                        PromptVisitorConditions.from({
                            sessionTimeOnSiteSeconds: parseInt(ev.target.value, 10),
                        }),
                    )
                }}
                style={{ width: 100 }}
            />
            <Space.Addon>
                <span>seconds spent on site</span>
            </Space.Addon>
        </Space.Compact>
    ) : null
}
